export enum CardModifierType {
    bomb = 'bomb',
    ice = 'ice',
    lowering = 'lowering',
    rising = 'rising',
    pickaxe = 'water',
    rope = 'rope',
    fog = 'fog',
    reward = 'reward',
    connected = 'connected',
    tnt = 'tnt',
    auto_collect = 'auto_collect',
    to_stack = 'to_stack',
    level_attempts = 'level_attempts',
}
